import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { EnvironmentService } from 'src/app/core/environment.service';
import { take } from 'rxjs/operators';
import { RegisterPageFormComponent } from '../../components/register-page-form/register-page-form.component';
import { TrackingDirective } from '@app/core/services/tracking/tracking.directive';
import { RedirectsService } from '@app/core/services/redirect/redirects.service';
import { LogoComponent } from '@app/shared/components/logo/logo.component';

@Component({
  selector: 'app-register-page-container',
  templateUrl: './register-page-container.component.html',
  styleUrls: ['./register-page-container.component.scss'],
  imports: [
    TrackingDirective,
    RegisterPageFormComponent,
    TranslateModule,
    LogoComponent,
  ],
})
export class RegisterPageContainerComponent implements OnInit {
  private activeRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private titleService = inject(Title);
  private translateService = inject(TranslateService);
  private redirectsService = inject(RedirectsService);
  env = inject(EnvironmentService);

  ngOnInit(): void {
    const title = this.translateService.instant('loginPage_subtitleLink');
    this.titleService.setTitle(title);
  }

  goToLogin(): void {
    this.redirectsService
      .getSecuredLoginRedirectUri(this.activeRoute.snapshot.queryParams)
      .pipe(take(1))
      .subscribe((loginRedirectUri) => {
        if (loginRedirectUri) {
          window.location.href = loginRedirectUri;
        } else {
          this.router.navigate(['/error'], { queryParamsHandling: 'preserve' });
        }
      });
  }
}
